import { S } from './style';

/**
 * This is the loading component displayed globally when switching between pages.
 * @returns
 */
export default function Loading() {
  return (
    <S.Wrapper>
      <S.Loader>
        <div>Loading</div>
      </S.Loader>
    </S.Wrapper>
  );
}
